import FormattedMessage from 'I18n/components/FormattedMessage';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { View } from 'foundations-components/transitional/components/View';
import { PPUIGridItem } from 'pricing-pages-ui-components/grid/PPUIGridItem';
import SkeletonLoadWrapper from '../../common/loading/SkeletonLoadWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FeaturesLayoutUI = ({
  loading,
  HeaderSection,
  FeaturesListSection,
  isCollapsible = false
}) => {
  if (isCollapsible) {
    return /*#__PURE__*/_jsx(AccordionItem, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "merchCards.businessObjectives.seeDetails"
      }),
      renderContent: () => {
        if (loading) {
          return null;
        }
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [HeaderSection, /*#__PURE__*/_jsx(View, {
            marginBlockStart: "300",
            children: FeaturesListSection
          })]
        });
      }
    });
  }
  return /*#__PURE__*/_jsxs(SkeletonLoadWrapper, {
    isLoading: loading,
    heights: [48, 48],
    widths: ['100%', '100%'],
    children: [/*#__PURE__*/_jsx(PPUIGridItem, {
      children: HeaderSection
    }), /*#__PURE__*/_jsx(PPUIGridItem, {
      marginBlockStart: "300",
      children: FeaturesListSection
    })]
  });
};